import React, { useState } from "react";
import allApi from "../../../api/allApi";
import inclogo from "../../../assets/images/inc-name-logo.png";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../localization/LocalizationContext";
import LoginBrandPanel from "./LoginBrandPanel";

const ForgotPassword = () => {
  const { localizationStrings } = useLocalization();
  const [email, setEmail] = useState("");
  const [resp, setResp] = useState(null);

  const handleSendClick = async (e) => {
    e.preventDefault();

    try {
      const api = new allApi();
      const payload = { email };
      const response = await api.postRequest("api/forgotPassword", payload);

      if (response) {
        setResp(response);
        console.log("Email sent successfully:", response);
      } else {
        console.error("Failed in sending mail");
      }
    } catch (error) {
      console.error("Failed to send email:", error);
    }
  };

  const userEmail = async (e) => {
    setEmail(e.target.value);
  };
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/");
  };

  const disableButton = !email;

  return (
    <div className="inc-login">
      <LoginBrandPanel />
      <div className="login-form">
        <div className="login-form-container">
          <div className="login-text">
            <img src={inclogo} alt="inc logo" className="inc-logo" />
            <h1>{localizationStrings?.forgotPassword}</h1>
            <p>
              {localizationStrings?.forgotPassInfo1} <br />
              {localizationStrings?.forgotPassInfo2}.
            </p>
          </div>
          <div className="inc-form line-textbox">
            <input
              type="email"
              placeholder="example@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button
            type="button"
            className="btn btn-login"
            onClick={handleSendClick}
            disabled={disableButton}
          >
            {localizationStrings?.send}
          </button>
          <div className="social-login">
            <div className="s-text" onClick={handleBack}>
              <span className="back-login">
                {localizationStrings?.backToLogin}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
